<template>
  <b-form-group
    label="Anasayfa Özet Metin Alanı"
    label-for="text1"
  >
    <validation-provider
      #default="{ errors }"
      name="Metin Alanı"
      rules="required"
    >
      <b-form-textarea
        id="text1"
        v-model="itemData.text1"
        placeholder="Metin Alanı"
        rows="10"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'Text1Content',
  components: {
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
  },
}
</script>
